import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from '@angular/core';
import { Validators } from '@angular/forms';
import {
	ActivatedRoute,
	Router,
} from '@angular/router';

import {
	catchError,
	map,
	tap,
} from 'rxjs/operators';

import { throwError } from 'rxjs';

import { BaseComponent } from '@rs-bank/rs-core';
import {
	CustomFormControlWithField,
	CustomFormGroup,
	ToggleField,
} from '@rs-bank/rs-forms-extention';
import {
	Column,
	FieldBoxForCustomFormControl,
	Layout,
	Row,
} from '@rs-bank/rs-layout';
import { detectChanges } from '@rs-bank/rs-rxjs-extention';


import { ApplicationErrors } from 'ib/internetbank-core/ib-exceptions/ib-exceptions';
import { EditField } from 'ib/internetbank-fields/field-types/edit.ib.field-types';
import { IbInputField } from 'ib/internetbank-fields/field-types/input.ib.field-types';

import { InternetbankAppApplicationException } from '../../../common/exceptions/exceptions';
import {
	ConstantsService,
	InternetBankSettings,
} from '../../../common/services/constants.service';
import { Mode } from '../../../ui/controls/message/mode';
import {
	DeprecatedPopUpService,
} from '../../../ui/controls/pop-up/pop-up.service';
import { BiometricsRegistrationErrorPopUpComponent } from '../biometrics-registration-error-pop-up/biometrics-registration-error.pop-up.component';
import { BiometricsRegistrationOfferStatementPopUpComponent } from '../biometrics-registration-offer-statement-pop-up/biometrics-registration-offer-statement.pop-up.component';
import {
	BiometricsRegistrationWizardService, GetVerificationInfoResponse,
} from '../biometrics-registration-wizard/biometrics-registration-wizard.service';
import { PreloginProduct } from '../biometrics-registration-wizard/models/models';


export enum BiometricsRegistrationVerificationInfoPopUpComponentQueryParameters {
	secret = 'res_secret',
	sid = 'sid',
	code = 'code',
}


@Component({
	selector: 'app-biometrics-registration-verification-info-pop-up',
	templateUrl: './biometrics-registration-verification-info.pop-up.component.html',
	styleUrls: ['./biometrics-registration-verification-info.pop-up.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [BiometricsRegistrationWizardService],
	standalone: false,
},

) export class BiometricsRegistrationVerificationInfoPopUpComponent extends BaseComponent implements OnInit {

	public static readonly routeSegment = 'biometrics-verification-info';

	@Input()
	public biometricsRegistrationErrorPopUpComponent: BiometricsRegistrationErrorPopUpComponent;

	@Input()
	public biometricsRegistrationOfferStatementPopUpComponent: BiometricsRegistrationOfferStatementPopUpComponent;

	@Output() public closeWindow: EventEmitter<boolean> = new EventEmitter();

	public secret = this.activatedRoute.snapshot.queryParams[BiometricsRegistrationVerificationInfoPopUpComponentQueryParameters.secret];
	public code = this.activatedRoute.snapshot.queryParams[BiometricsRegistrationVerificationInfoPopUpComponentQueryParameters.code];
	public sid = this.activatedRoute.snapshot.queryParams[BiometricsRegistrationVerificationInfoPopUpComponentQueryParameters.sid];

	public MEssageMode = Mode;

	public readonly popUpId = 'biometrics-registration-verification-info-pop-up-id';

	public errors: ApplicationErrors | undefined;

	public form = new CustomFormGroup<GetVerificationInfoResponse>({
		birthDate: new CustomFormControlWithField({}),
		docNumber: new CustomFormControlWithField({}),
		docSeries: new CustomFormControlWithField({}),
		email: new CustomFormControlWithField({}),
		firstName: new CustomFormControlWithField({}),
		gender: new CustomFormControlWithField({}),
		issueDate: new CustomFormControlWithField({}),
		issuedBy: new CustomFormControlWithField({}),
		lastName: new CustomFormControlWithField({}),
		middleName: new CustomFormControlWithField({}),
		mobilePhone: new CustomFormControlWithField({}),
		snils: new CustomFormControlWithField({}),
	});
	public toggleControl = new CustomFormControlWithField({}, false, Validators.requiredTrue);

	public layout: Layout<Column>;

	public stepIndex: number = 0;

	public settings: InternetBankSettings = ConstantsService.SETTINGS;
	public resetActivated: boolean = false;

	public conditions$ = this.biometricsRegistrationWizardService.getPreloginProducts(
		this.biometricsRegistrationWizardService.productIdForGetPreloginProducts,
	)
		.pipe(
			map((data: Array<PreloginProduct>) => data[0]?.additionalConditions),
		);

	public isOpenConditions: boolean;

	constructor(
		private modalService: DeprecatedPopUpService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		public override changeDetectorRef: ChangeDetectorRef,
		public biometricsRegistrationWizardService: BiometricsRegistrationWizardService,
	) {
		super(changeDetectorRef);
	}

	public openModal(id: string): void {
		this.modalService.open(id);
	}

	public closeModal(id: string): void {
		this.closeWindow.emit(false);
		this.modalService.close(id);
	}

	public ngOnInit(): void {

	}

	public showPopUp(): void {
		this.closeWindow.emit(true);

		this.init();

		this.changeDetectorRef.markForCheck();
	}

	public close(): void {
		this.closeModal(this.popUpId);
	}

	public next(): void {
		// eslint-disable-next-line @typescript-eslint/typedef
		this.biometricsRegistrationWizardService.updateVerificationInfo(this.form.getCustomFormControl(c => c.email).value)
			.pipe(
				catchError((error: InternetbankAppApplicationException) => {
					this.errors = error.errors;
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					return throwError((error: any) => error);
				}),
				tap(() => {
					this.close();
					this.biometricsRegistrationOfferStatementPopUpComponent.showPopUp();
				}),
				detectChanges(this),
			)
			.subscribe();
	}

	public openCondirions(): void {
		this.isOpenConditions = true;
	}

	public conditionsClickOnTitle(): void {
		this.isOpenConditions = false;
	}

	private init(): void {

		this.biometricsRegistrationWizardService.verificationLog(window.location.href)
			.subscribe();

		this.biometricsRegistrationWizardService.getVerificationInfo(this.secret)
			.pipe(
				tap((data: GetVerificationInfoResponse) => {
					data.gender = data.gender === 'F' ? 'женский' : 'мужской';
					this.form.patchValue(data);

					this.openModal(this.popUpId);
				}),
				catchError((error: InternetbankAppApplicationException) => {

					this.biometricsRegistrationErrorPopUpComponent.exception = error;
					this.biometricsRegistrationErrorPopUpComponent.showPopUp();

					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					return throwError((error: any) => error);
				}),
				detectChanges(this),
			)
			.subscribe();

		this.layout = new Layout(new Column([
			new Row([
				new FieldBoxForCustomFormControl(
					// eslint-disable-next-line @typescript-eslint/typedef
					this.form.getCustomFormControl(c => c.lastName),
					new IbInputField({
						label: 'Фамилия',
						disabled: true,
					}),
				),
				new FieldBoxForCustomFormControl(
					// eslint-disable-next-line @typescript-eslint/typedef
					this.form.getCustomFormControl(c => c.firstName),
					new IbInputField({
						label: 'Имя',
						disabled: true,
					}),
				),
				new FieldBoxForCustomFormControl(
					// eslint-disable-next-line @typescript-eslint/typedef
					this.form.getCustomFormControl(c => c.middleName),
					new IbInputField({
						label: 'Отчество',
						disabled: true,
					}),
				),
			]),

			new Row([
				new FieldBoxForCustomFormControl(
					// eslint-disable-next-line @typescript-eslint/typedef
					this.form.getCustomFormControl(c => c.birthDate),
					new IbInputField({
						label: 'Дата рождения',
						disabled: true,
					}),
				),
				new FieldBoxForCustomFormControl(
					// eslint-disable-next-line @typescript-eslint/typedef
					this.form.getCustomFormControl(c => c.gender),
					new IbInputField({
						label: 'Пол',
						disabled: true,
					}),
				),
				new FieldBoxForCustomFormControl(
					// eslint-disable-next-line @typescript-eslint/typedef
					this.form.getCustomFormControl(c => c.issueDate),
					new IbInputField({
						label: 'Дата выдачи паспорта',
						disabled: true,
					}),
				),
			]),

			new Row([
				new FieldBoxForCustomFormControl(
					// eslint-disable-next-line @typescript-eslint/typedef
					this.form.getCustomFormControl(c => c.docNumber),
					new IbInputField({
						label: 'Серия и номер паспорта',
						disabled: true,
					}),
				),
				new FieldBoxForCustomFormControl(
					// eslint-disable-next-line @typescript-eslint/typedef
					this.form.getCustomFormControl(c => c.issuedBy),
					new IbInputField({
						label: 'Выдан',
						disabled: true,
					}),
				),
				new FieldBoxForCustomFormControl(
					// eslint-disable-next-line @typescript-eslint/typedef
					this.form.getCustomFormControl(c => c.snils),
					new IbInputField({
						label: 'СНИЛС',
						disabled: true,
					}),
				),
			]),

			new Row([
				new FieldBoxForCustomFormControl(
					// eslint-disable-next-line @typescript-eslint/typedef
					this.form.getCustomFormControl(c => c.mobilePhone),
					new IbInputField({
						label: 'Основной телефон',
						disabled: true,
					}),
				),
				new FieldBoxForCustomFormControl(
					// eslint-disable-next-line @typescript-eslint/typedef
					this.form.getCustomFormControl(c => c.mobilePhone),
					new IbInputField({
						label: 'Дополнительный телефон',
						disabled: true,
					}),
				),
				new FieldBoxForCustomFormControl(
					// eslint-disable-next-line @typescript-eslint/typedef
					this.form.getCustomFormControl(c => c.email),
					new EditField(
						new IbInputField({ label: 'Email' }),
						{},
					)),
			]),

			new Row([
				new FieldBoxForCustomFormControl(
					this.toggleControl,
					new ToggleField({ label: 'Мои данные верны' }),
				),
			]),

		]));
	}

}
